import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { useCompany } from '../contexts/CompanyContext';
import { completeLogin } from '../lib/api';

/**
 * Точка возврата после входа через Яндекс: /auth/callback?token=...
 * Бэкенд уже создал/нашёл пользователя и (при первом входе) компанию —
 * здесь только сохраняем сессию и решаем, куда вести дальше.
 */
export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { selectCompany } = useCompany();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const token = searchParams.get('token');
    if (!token) {
      toast.error('Не удалось завершить вход через Яндекс');
      navigate('/login');
      return;
    }

    completeLogin(token, { selectCompany })
      .then((destination) => {
        toast.success('Добро пожаловать!');
        navigate(destination);
      })
      .catch(() => {
        toast.error('Не удалось завершить вход');
        navigate('/login');
      });
  }, [searchParams, navigate, selectCompany]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Завершаем вход...</p>
      </div>
    </div>
  );
}
